import DeviceDeleteConfirmationAlert from "./DeviceDeleteConfirmationAlert";

export default DeviceDeleteConfirmationAlert
